var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsernameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C24.462 0 29.7 5.29091 29.7 11.8182C29.7 15.8091 27.7425 19.3364 24.7446 21.4764C31.1616 24.3409 36 31.0091 36 38.1818C36 38.664 35.8104 39.1265 35.4728 39.4675C35.1352 39.8084 34.6774 40 34.2 40C33.7226 40 33.2648 39.8084 32.9272 39.4675C32.5896 39.1265 32.4 38.664 32.4 38.1818C32.4 30.6509 25.4556 23.6364 18 23.6364C10.5444 23.6364 3.6 30.6509 3.6 38.1818C3.6 38.664 3.41036 39.1265 3.07279 39.4675C2.73523 39.8084 2.27739 40 1.8 40C1.32261 40 0.864773 39.8084 0.527208 39.4675C0.189642 39.1265 0 38.664 0 38.1818C0 31.0082 4.8393 24.3409 11.2554 21.4764C9.72307 20.386 8.47292 18.9393 7.61046 17.2583C6.74799 15.5774 6.29853 13.7115 6.3 11.8182C6.3 5.29091 11.538 0 18 0ZM18 3.63636C15.8517 3.63636 13.7915 4.49837 12.2724 6.03276C10.7534 7.56715 9.9 9.64823 9.9 11.8182C9.9 13.9881 10.7534 16.0692 12.2724 17.6036C13.7915 19.138 15.8517 20 18 20C20.1483 20 22.2085 19.138 23.7276 17.6036C25.2466 16.0692 26.1 13.9881 26.1 11.8182C26.1 9.64823 25.2466 7.56715 23.7276 6.03276C22.2085 4.49837 20.1483 3.63636 18 3.63636Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsernameIcon);
export default __webpack_public_path__ + "static/media/username_icon.2a4cb1a56eded2b8bbdf5854e5ab03b7.svg";
export { ForwardRef as ReactComponent };